<template>
  <a-card id="dataAuthority">
    <div class="content">
      <a-tabs default-active-key="1" @change="changeTab">
        <a-button slot="tabBarExtraContent" icon="save" type="primary" @click="submitRole()">保存</a-button>

        <a-tab-pane v-for="item in applyList" :key="item.id" :tab="item.name">
          <div class="main" style="margin-top: 15px">
            <a-table :loading="tableLoading" key="id" :columns="columns" :pagination="false" :data-source="dataSource">
              <!-- <template slot="action" slot-scope="text, record">
                                <a-switch v-if="!record.children" checked-children="启用" un-checked-children="禁用" v-model="record.hasSelect" @click="changeStatus(record)"/>
                            </template> -->
              <template slot="name" slot-scope="text, record">
                <a-checkbox @change="onCheckChange($event, record)" :class="isHalf(record) ? 'check-half' : ''" :checked="isChecked(record)" v-if="isChildren(record)">
                  {{ text }}
                </a-checkbox>
                <span v-else>{{ text }}</span>
              </template>
              <template slot="action" slot-scope="text">
                <span v-for="(item, index) in text.childrens" :key="item.name + item.id + index" style="margin-right: 15px; display: inline-block">
                  <a-checkbox v-model="item.hasSelect" @change="changeItem($event, index, text.childrens)"> {{ item.name }} </a-checkbox>
                </span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'

const columns = [
  // { title: '模块', dataIndex: 'name', width: '250px', scopedSlots: { customRender: 'name' }, key: 'name', ellipsis: true },
  { title: '权限', scopedSlots: { customRender: 'action' }, key: 'action' },
]

export default {
  name: 'dataAuthority',
  computed: {
    isChildren() {
      return function (record) {
        const flag1 = record.childrens && record.childrens.length
        return flag1
      }
    },
    isChecked() {
      return function (record) {
        const children = record.childrens || []
        const stack = [...children]
        let flag = false
        while (stack.length) {
          const item = stack.pop()
          flag = item?.hasSelect
          if (!flag) return false
          const itemChildren = item.childrens
          if (itemChildren && itemChildren.length) {
            itemChildren.forEach((v) => stack.push(v))
          }
        }
        return flag
      }
    },
    /** 判断半选 */
    isHalf() {
      return function (record) {
        const children = [...(record.childrens || [])].flat(10)
        const stack = [...children]
        const tf = {
          t: 0,
          f: 0,
        }

        while (stack.length) {
          const item = stack.pop()
          item.hasSelect === true && tf.t++
          item.hasSelect === false && tf.f++
          if (tf.t && tf.f) {
            return true
          }
          const itemChildren = [...(item.children || [])].flat(10)
          if (itemChildren && itemChildren.childrens) {
            itemChildren.forEach((v) => stack.push(v))
          }
        }
        return tf.t && tf.f ? true : false
      }
    },
  },
  data() {
    return {
      columns,
      tableLoading: false,
      dataSource: [],
      dataList: [],

      applyList: [], //应用
      roleId: '', //角色ID
    }
  },
  created() {
    this.getApplyList()
    this.roleId = this.$route.query.roleId
  },
  mounted() {
    const arr = ['首页', '权限系统', { name: '系统角色', path: '/settings/Roles' }, '数据权限']
    $Bus.$emit('pageHeaderBreadcrumb', arr)
  },
  methods: {
    changeItem(e, index, item) {
      this.$set(item[index], 'hasSelect', e.target.checked)
    },
    /** 勾选某一模块 */
    onCheckChange(e, record) {
      this.resverAuthority([record], e.target.checked)
    },
    /** 改变勾选状态 */
    resverAuthority(data, flag) {
      data.forEach((v) => {
        if (v.hasOwnProperty('hasSelect')) {
          v.hasSelect = flag
        }
        if (v.childrens && v.childrens.length) {
          this.resverAuthority(v.childrens, flag)
        }
      })
    },
    submitRole() {
      const checkArr = []

      function getCheckedId(arr) {
        arr.forEach((v) => {
          if (v.hasSelect) {
            checkArr.push(v.id)
          }
          if (v.childrens && v.childrens.length) {
            getCheckedId(v.childrens)
          }
        })
      }
      getCheckedId(this.dataSource)
      let params = {
        roleAuthorityItems: [
          {
            roleId: +this.$route.query.roleId,
            appId: +this.appid,
            authIds: checkArr,
            authorityType: 2,
          },
        ],
      }
      this.$message.destroy()
      this.$http.Mechanism.editDataAuthority(params).then((res) => {
        this.$message.success(res.message)
        this.getList(this.appid)
      })
    },
    // 获取应用
    getApplyList() {
      this.$http.applicationList({ roleType: this.$route.query.roleType }).then((res) => {
          this.applyList = res.data.data
          this.appid = res.data.data[0].id
          this.getList(this.appid)
      })
    },
    // 切换应用
    changeTab(appid) {
      this.appid = appid
      this.getList(appid)
    },
    // 获取数据
    getList(appid) {
      let params = {
        roleid: this.roleId,
        appid: appid,
      }
      this.tableLoading = true
      this.$http.Mechanism.getDataAuthorityList(params).then((res) => {
        this.tableLoading = false
        const { data } = res
        let dataInfo = {}
          data.forEach((item, index) => {
            let { groupName } = item
            if (!dataInfo[groupName]) {
              dataInfo[groupName] = {
                groupName,
                name: groupName,
                childrens: [],
              }
            }
            dataInfo[groupName].childrens.push(item)
          })
          this.dataSource = Object.values(dataInfo)
          console.log(this.dataSource, '===')
      })
    },
    changeStatus(record) {
      this.dataSource.forEach((v) => {
        if (v.name == record.groupName) {
          v.children.forEach((el) => {
            if (el.id !== record.id) {
              el.hasSelect = false
            } else {
              el.hasSelect = record.hasSelect
            }
          })
        }
      })
    },
  },
}
</script>

<style scoped>
#dataAuthority >>> .searchForm {
  display: flex;
}

#dataAuthority >>> .searchForm .fold {
  width: 80%;
  display: flex;
}
::v-deep .ant-table-row-expanded {
  display: none;
}
</style>
<style lang="less" scoped>
.search {
  margin-bottom: 54px;
}

.fold {
  width: calc(100% - 216px);
  display: inline-block;
}

.operator {
  margin-bottom: 18px;
}

.standard-table .alert {
  display: none;
}

.main {
  width: 100%;
  .tree {
    width: 15%;
    height: 400px;
    background-color: #fff;
    padding: 0 15px;
  }
  .r_content {
    flex: 1;
    margin-left: 20px;
    background-color: #fff;
    position: relative;

    .rolesBox {
      .btns {
        display: flex;
        justify-content: center;
        margin-top: 30px;
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}
</style>
